export const BUILD_VERSION = '1791330230';
